export const scaleValues: Record<string, string> = {
  "0": "0", "50": "0.5", "75": "0.75", "90": "0.9", "95": "0.95",
  "100": "1", "105": "1.05", "110": "1.1", "125": "1.25", "150": "1.5",
};

export const rotateValues: Record<string, string> = {
  "0": "0deg", "1": "1deg", "2": "2deg", "3": "3deg",
  "6": "6deg", "12": "12deg", "45": "45deg", "90": "90deg", "180": "180deg",
};

export const skewValues: Record<string, string> = {
  "0": "0deg", "1": "1deg", "2": "2deg",
  "3": "3deg", "6": "6deg", "12": "12deg",
};

export const transformOriginValues: Record<string, string> = {
  center: "center", top: "top", "top-right": "top right",
  right: "right", "bottom-right": "bottom right", bottom: "bottom",
  "bottom-left": "bottom left", left: "left", "top-left": "top left",
};
